import { act } from "react-dom/test-utils";
import { ActionTypes } from "../action-type";

const initialState = {
    joined_as:null,
    code:null,
    debate_id:null,
    room_id:null
}

export const joiningDebateReducer = (state = initialState,action)=>{
    switch(action.type){
        case ActionTypes.JOINING_DEBATE:
            return {...state,
                joined_as:action.payload.joined_as,
                code:action.payload.code,
                debate_id:action.payload.debate_id,
                room_id:action.payload.room_id
            }
        default:
            return state;
    }
}